<a [href]="link" target="_blank"><img [style]="'max-height:' + size + 'px;'" src="/assets/icons/traffit.png" alt="Icon" /></a>
